module.exports = __webpack_public_path__ + "img/tab06.0c2009ea.jpg";